import 'css-chunksrc/client/pages/dummyPage/styles.scss';export default {
  "dummyPage": "_dummyPage_d50zp_1",
  "main": "_main_d50zp_9"
};